export default "__VITE_ASSET__c1092cbc__"